import React from 'react';
import { OptionGroupLinkStatus } from '@/types';
import { Trans } from '@lingui/react/macro';

export const StatusActionLabel: React.FC<{ status: OptionGroupLinkStatus | null }> = ({ status }) => {
    if (status === OptionGroupLinkStatus.Rejected) return <Trans>Reject</Trans>;
    if (status === OptionGroupLinkStatus.Approved) return <Trans>Publish</Trans>;
    return <Trans>Unpublish</Trans>;
};

export const StatusActionRoomsTitle: React.FC<{ status: OptionGroupLinkStatus | null }> = ({ status }) => {
    if (status === OptionGroupLinkStatus.Rejected) return <Trans>Reject rooms</Trans>;
    if (status === OptionGroupLinkStatus.Approved) return <Trans>Publish rooms</Trans>;
    return <Trans>Unpublish rooms</Trans>;
};

export const StatusActionUnitsTitle: React.FC<{ status: OptionGroupLinkStatus | null }> = ({ status }) => {
    if (status === OptionGroupLinkStatus.Rejected) return <Trans>Reject units</Trans>;
    if (status === OptionGroupLinkStatus.Approved) return <Trans>Publish units</Trans>;
    return <Trans>Unpublish units</Trans>;
};
